import CloseIcon from '@mui/icons-material/Close'
import { IconButton, useTheme } from '@mui/material'
import { useSnackbar } from 'notistack'

interface IProps {
  buttonKey: string | number
}

const SnackbarNotificationCloseButton = (props: IProps) => {
  const { buttonKey } = props

  const { closeSnackbar } = useSnackbar()
  const theme = useTheme()

  return (
    <IconButton onClick={() => closeSnackbar(buttonKey)} aria-label="Close notification">
      <CloseIcon fontSize="small" sx={{ color: theme.palette.common.white }} />
    </IconButton>
  )
}

export default SnackbarNotificationCloseButton
